// extracted by mini-css-extract-plugin
export default {"arrow":"webpack-components-core-Tooltip-components-TooltipArrow-TooltipArrow-module__arrow"};